import { Component, OnInit, Optional, Inject } from '@angular/core';
import {
    Validators,
    FormGroup,
    FormControl,
    FormBuilder
} from '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from '../../../../services/user.service';
import { AuthenticationService } from '../../../../services/student-authentication.service';
import { AppLoaderService } from 'app/shared/services/app-loader/app-loader.service';
import { CacheService } from '../../../../services/cache.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
    signInForm: FormGroup;
    genericError: string = undefined;
    showUserUnconfirmed: boolean = false;


    constructor(
        private fb: FormBuilder,
        private router: Router,
        private userService: UserService,
        private authenticationService: AuthenticationService,
        private loader: AppLoaderService,
        private _cacheService: CacheService
    ) {
    }

    ngOnInit() {
        const password = new FormControl('', Validators.required);
        this.signInForm = this.fb.group({
            email: [
                '',
                [Validators.required, Validators.email]
            ],
            password: password
        });
    }

    async onSubmit() {
        if (!this.signInForm.invalid) {
            const signinData = this.signInForm.value;
            this.resetErrorMessaging();
            try {
                this.loader.open('Please wait');
                this._cacheService.remove('student');

                await this.authenticationService.login(
                    signinData.email,
                    signinData.password
                );
                this.loader.close();
                this.userService.setClaims();

                if (this.userService.getReverifyEmail() === 'true') {
                    this.verifyEmail();
                } else {
                    this.router.navigate(['/']);
                }
            } catch (err) {
                this.loader.close();
                if (JSON.parse(err.response).message.includes('Incorrect username or password.')) {
                    this.genericError = 'Sorry, your email and/or password are incorrect.';
                    this.signInForm.controls.password.reset();
                } else if (JSON.parse(err.response).message.includes('User is not confirmed.')) {
                    this.showUserUnconfirmed = true;
                } else if (JSON.parse(err.response).message.includes('Too many requests')) {
                    this.genericError = 'The system is currently experiencing high usage. Please wait a few minutes and try again.';
                }
            }
        }
    }

    private resetErrorMessaging() {
        this.showUserUnconfirmed = false;
        this.genericError = undefined;
    }

    confirmSetup() {
        const signupData = this.signInForm.value;
        this.setUser(signupData);
        this.router.navigate(['/sessions/register-confirmation']);
    }

    verifyEmail() {
        const signupData = this.signInForm.value;
        this.setUser(signupData);
        this.router.navigate(['/sessions/email-verification']);
    }

    setUser(signupData) {
        this.userService.user = {
            username: signupData.email,
            password: signupData.password,
            code: ''
        };
    }


}
